import { render, staticRenderFns } from "./RestApi.vue?vue&type=template&id=8d5cb89e&scoped=true"
import script from "./RestApi.vue?vue&type=script&lang=js"
export * from "./RestApi.vue?vue&type=script&lang=js"
import style0 from "./RestApi.vue?vue&type=style&index=0&id=8d5cb89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5cb89e",
  null
  
)

export default component.exports